export default __webpack_public_path__ + "static/media/coolearthAd.475595692a11cfea7e24e6d7f1c82e56.png";